import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Routes } from './routes';
import { Router, ActivatedRoute } from '@angular/router';
import { findIndex, find } from 'lodash-es';

@Injectable()
export class PartnerCustomization {
    public appVersion: number;
    public isSciExcluded: boolean;

    constructor(
        private _router: Router,
        private _activateRoute: ActivatedRoute
    ) {
        this.appVersion = environment.appVersion;
        this.isSciExcluded = environment.isSciExcluded;

        this._activateRoute.queryParams.subscribe((params) => {
            if (params['v'] === '4') {
                this.isSciExcluded = false;
            }
        });
    }

    goToNextScreen(currentScreen, action?) {
        let nextRoute = '';
        if (currentScreen == '/') {
            currentScreen = '/home';
        }
        if (action == 'error') {
            nextRoute = Routes[this.appVersion].error;
        }
        let currentRouteIndex =
            Routes[this.appVersion].normal.indexOf(currentScreen);
        if (currentRouteIndex !== -1 && action == undefined) {
            nextRoute = Routes[this.appVersion].normal[currentRouteIndex + 1];
        }
        if (currentScreen == 'quote-list') {
            nextRoute =
                Routes[this.appVersion].retrieveQuoteByEmail[
                    currentRouteIndex + 1
                ];
        }
        this._router.navigate([nextRoute]);
    }

    /**
     * Use the product steps and selected products to determine the next route - Additional info -> Policy Limits -> Optional Coverages -> Next product || application summary
     */
    goToNextScreenUsingProgressBarRoutes(
        currentRoute,
        selectedProducts,
        currentProductIndex,
        skipProduct = false,
        showEligibilityQuestions?
    ) {
        let currentStepIndex;
        let nextRoute: string;
        const currentProduct = selectedProducts[currentProductIndex];

        if (currentRoute === '/get-acquainted') {
            selectedProducts.forEach((product) => {
                if (
                    product.isEligible &&
                    !nextRoute &&
                    product.productSteps.length > 0
                ) {
                    nextRoute = product.productSteps[0].associatedUrl;
                }
            });
        } else if (currentRoute === '/business-details') {
            if (showEligibilityQuestions) {
                nextRoute = '/get-acquainted';
            } else {
                if (selectedProducts && selectedProducts.length > 0) {
                    nextRoute =
                        selectedProducts[0].productSteps[0].associatedUrl;
                } else {
                    nextRoute = '/not-eligible';
                }
            }
        } else {
            // Find out what step index we are on
            currentStepIndex = findIndex(
                currentProduct.productSteps,
                (step) => {
                    return step['associatedUrl'] === currentRoute;
                }
            );
            // if there is another step for this product, go to the next step
            if (
                currentStepIndex < currentProduct.productSteps.length - 1 &&
                !skipProduct
            ) {
                // if SCI BOP was skipped previously, but now is revisited, unskip umbrella
                if (
                    (currentProduct.productId === 'BOP' ||
                        currentProduct.productId === 'GL') &&
                    currentProduct.productSourceSystem === 'SCI'
                ) {
                    // find umbrella
                    let umbrellaProduct = find(
                        selectedProducts,
                        (selectedProduct) => {
                            return selectedProduct.productId === 'UMBRELLA';
                        }
                    );
                    // Unskip umbrella
                    if (umbrellaProduct) {
                        umbrellaProduct['disqualifyProduct'] = false;
                    }
                }
                nextRoute =
                    currentProduct.productSteps[+currentStepIndex + 1]
                        .associatedUrl;
                // else go to the next product
            } else {
                // if SCI BOP was skipped from policy limits, but then revisited, unskip umbrella
                if (
                    (currentProduct.productId === 'BOP' ||
                        currentProduct.productId === 'GL') &&
                    currentProduct.productSourceSystem === 'SCI' &&
                    find(currentProduct.productSteps, (step) => {
                        return step.associatedUrl === currentRoute;
                    })
                ) {
                    // find umbrella
                    let umbrellaProduct = find(
                        selectedProducts,
                        (selectedProduct) => {
                            return selectedProduct.productId === 'UMBRELLA';
                        }
                    );
                    // Unskip umbrella
                    if (umbrellaProduct) {
                        umbrellaProduct['disqualifyProduct'] = false;
                    }
                }
                // if SCI BOP is skipped, skip umbrella
                if (
                    (currentProduct.productId === 'BOP' ||
                        currentProduct.productId === 'GL') &&
                    currentProduct.productSourceSystem === 'SCI' &&
                    skipProduct
                ) {
                    // find umbrella
                    let umbrellaProduct = find(
                        selectedProducts,
                        (selectedProduct) => {
                            return selectedProduct.productId === 'UMBRELLA';
                        }
                    );
                    // add a skip product flag
                    if (umbrellaProduct) {
                        umbrellaProduct['disqualifyProduct'] = true;
                    }
                }
                // check for next product, if product is not disqualifide, then skip to next section
                if (
                    selectedProducts[+currentProductIndex + 1] &&
                    !selectedProducts[+currentProductIndex + 1]
                        .disqualifyProduct
                ) {
                    // if exists, go to next products first product step
                    nextRoute =
                        selectedProducts[+currentProductIndex + 1]
                            .productSteps[0].associatedUrl;
                    // if there is a next product and its disqualified, check for next product after that, and navigate accordingly
                } else if (
                    selectedProducts[+currentProductIndex + 1] &&
                    selectedProducts[+currentProductIndex + 1]
                        .disqualifyProduct &&
                    selectedProducts[+currentProductIndex + 2]
                ) {
                    // Skip the disqualified product and go to the next
                    nextRoute =
                        selectedProducts[+currentProductIndex + 2]
                            .productSteps[0].associatedUrl;
                    // if no more products, go to additional info page
                } else {
                    nextRoute = '/review-application';
                }
            }
        }
        this._router.navigate([nextRoute]);
    }

    goDirectToScreen(route, productIndex?) {
        this._router.navigate([route]);
    }

    goToHome() {
        this._router.navigate(['']);
    }
}
